import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CTable,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTooltip,CFormLabel 
} from '@coreui/react'
import PatientInfo from './PatientInfo.jsx'
import PatientViewNotePopup from './PatientViewNotePopup.jsx'
import Select from 'react-select'
import { FunnelPlotOutlined } from '@ant-design/icons'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import { RotateCcw,Trash2,X,Eye  } from 'lucide-react'
import React, { useDeferredValue ,useEffect, useMemo, useState } from 'react'
import Pageloader from '../../components/shared/Pageloader.jsx'
import SavePatients from '../../services/general/savePatientinformation.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config.js'
import { patientMatchesSearch } from '../../utils/searchUtils'
import './Patient.css'
import './dashboard.css'
import PatientAppointmentDetails from '../../services/general/appointmentData.api.js'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api.js'
import { motion } from 'framer-motion'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'


 
const Archive = () => {
  const [patientTheme, setPatientTheme] = useState(() => localStorage.getItem('provio_theme') || 'dark')
  const [archivedPatients, setArchivedPatients] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [loadError, setLoadError] = useState(false)
  const [unarchivePatient, setUnarchivePatient] = useState(null)
  const [isUnarchiving, setIsUnarchiving] = useState(false)
  const [deletePatient, setDeletePatient] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)
   const [rowClicked, setRowClicked] = useState(null)
  const [facilities, setFacilities] = useState([])
    const [showFilter, setShowFilter] = useState(false)
    const [patientIDClicked, setPatientIDClicked] = useState(-1)
    const [dataCallType, setDataCallType] = useState(null)
const [showNotePopup, setShowNotePopup] = useState(false)
 const [setDataId, setEditDataId] = useState(null)
const [showPatientInfo, setShowPatientInfo] = useState(false)
const [noteID, setNoteID] = useState(null)
  const [patientModelVisible, setPatientModalVisible] = useState(false)
     const [filterData, setFilterData] = useState({
  facility: [],
  searchValue: '',
  DOB: '',
  patientType: [],
})


      const selectPatientTypeOption = [
  { value: 'Short Term', label: 'Short Term' },
  { value: 'Long Term', label: 'Long Term' },
];



const parseApiData = (response, fallback = []) => {
  try {
     console.log('parseApiData response:', JSON.parse(response?.d)?.Data)
    return JSON.parse(response?.d)?.Data ?? fallback
  } catch (error) {
    console.error('Error parsing API data:', error)
    return fallback
  }
}


 const getFacilities = async () => {
    try {
      let a = await FacilityCRUD('SELECT', {})
      if (a && a.d) {
        let data = JSON.parse(a.d)?.Data
        const formattedData = data.map(formatFacilityOption)
        setFacilities(formattedData)
        setSelectedFacility(formattedData[0])
      } else {
        console.error('Failed to fetch facilities: Invalid API response', a)
      }
    } catch (e) {
      console.error('Error parsing facilities:', e)
    }
  }

const isArchivedPatient = (patient) => {
  const archiveValue = patient?.isArchive ?? patient?.IsArchive
  return archiveValue === true || archiveValue === 1 || String(archiveValue).toLowerCase() === 'true'
}

const getPatientName = (patient) =>
  [patient?.FirstName, patient?.MiddleName, patient?.LastName]
    .filter(Boolean)
    .join(' ')
    .trim()

const handleViewNote = (patient) => {
  if (!patient?.PatientID) {
    toast.error('Patient details not found', toastConfig)
    return
  }

  setPatientIDClicked(patient.PatientID)
  setRowClicked(patient)
  setDataCallType(null)
  setNoteID(null)

  // Show note content
  setShowNotePopup(true)

  // Open modal
  setPatientModalVisible(true)
}
  useEffect(() => {
    const handleThemeChange = () => {
      setPatientTheme(localStorage.getItem('provio_theme') || 'dark')
    }

    window.addEventListener('storage', handleThemeChange)
    window.addEventListener('provio-theme-change', handleThemeChange)

    return () => {
      window.removeEventListener('storage', handleThemeChange)
      window.removeEventListener('provio-theme-change', handleThemeChange)
    }
  }, [])

  useEffect(() => {
    let isMounted = true

    const loadArchivedPatients = async () => {
      setIsLoading(true)
      setLoadError(false)

      try {
        const patientData = await SavePatients('getarchive', '', '', '')
      
        const patients = parseApiData(patientData, [])
           console.log('Archived patients data:', patientData , patients)

        if (isMounted) {
          setArchivedPatients(patients)
        }
      } catch (error) {
        if (isMounted) {
          setArchivedPatients([])
          setLoadError(true)
        }
      } finally {
        if (isMounted) {
          setIsLoading(false)
        }
      }
    }

    loadArchivedPatients()


    return () => {
      isMounted = false
    }
  }, [])


  useEffect(() => {
  const uniqueFacilities = [
    ...new Map(
      archivedPatients
        .filter((patient) => patient?.FacilityName)
        .map((patient) => [
          patient.FacilityID || patient.FacilityId || patient.FacilityName,
          {
            value:
              patient.FacilityID ||
              patient.FacilityId ||
              patient.FacilityName,
            label: patient.FacilityName,
          },
        ])
    ).values(),
  ]

  setFacilities(uniqueFacilities)
}, [archivedPatients])

const deferredSearchValue = useDeferredValue(searchValue)

const filteredPatients = useMemo(() => {
  const selectedFacilityLabels = new Set(
    facilities
      .filter((fac) => filterData.facility.includes(fac.value))
      .map((fac) => fac.label)
  )

  return archivedPatients
    .filter((patient) => {
      const matchesFacility =
        filterData.facility.length === 0 ||
        selectedFacilityLabels.has(patient?.FacilityName)

      const matchesPatientType =
        filterData.patientType.length === 0 ||
        filterData.patientType.includes(patient?.PatientType)

      const matchesDate =
        !filterData.DOB ||
        patient?.DOB === filterData.DOB

      const matchesSearchValue =
        !deferredSearchValue ||
        patientMatchesSearch(patient, deferredSearchValue, {
          facilityName: patient?.FacilityName,
        })

      return (
        matchesFacility &&
        matchesPatientType &&
        matchesSearchValue &&
        matchesDate
      )
    })
    .sort((patientA, patientB) =>
      getPatientName(patientA).localeCompare(
        getPatientName(patientB),
        undefined,
        { sensitivity: 'base' }
      )
    )
}, [
  archivedPatients,
  facilities,
  filterData.facility,
  filterData.patientType,
  filterData.DOB,
  deferredSearchValue,
])
  const groupedPatients = useMemo(() => {
    return filteredPatients.reduce((groups, patient) => {
      const facilityName = String(patient?.FacilityName || '').trim() || 'Unknown Facility'

      if (!groups[facilityName]) {
        groups[facilityName] = []
      }

      groups[facilityName].push(patient)
      return groups
    }, {})
  }, [filteredPatients])

  const facilityGroups = Object.entries(groupedPatients).sort(([facilityA], [facilityB]) =>
    facilityA.localeCompare(facilityB, undefined, { sensitivity: 'base' }),
  )

  const handleUnarchivePatient = async () => {
    const patientId = unarchivePatient?.PatientID

    if (!patientId) {
      toast.error('Patient ID not found', toastConfig)
      return
    }

    setIsUnarchiving(true)

    try {
      const response = await SavePatients('unarchive', '', '', '', patientId, '')

      if (response instanceof Error || response?.isAxiosError) {
        throw response
      }

      setArchivedPatients((patients) => patients.filter((patient) => patient.PatientID !== patientId))
      setUnarchivePatient(null)
      toast.success('Patient Restored Successfully', toastConfig)
    } catch (error) {
      console.error('Failed to restore patient:', error)
      toast.error('Failed to restore patient', toastConfig)
    } finally {
      setIsUnarchiving(false)
    }
  }

  const handleDeletePatient = async () => {
  const patientId = deletePatient?.PatientID

  if (!patientId) {
    toast.error('Patient ID not found', toastConfig)
    return
  }

  setIsDeleting(true)

  try {
    await Promise.all([
      removePatientFromAppointments(patientId),
      removePatientNotes(patientId),
    ])

    // Permanent delete
    const response = await SavePatients(
      'delete',
      '',
      '',
      '',
      patientId,
      '',
    )

    if (response instanceof Error || response?.isAxiosError) {
      throw response
    }

    // Remove deleted patient from archive list
    setArchivedPatients((patients) =>
      patients.filter((patient) => patient.PatientID !== patientId),
    )

    setDeletePatient(null)
    toast.success('Patient Deleted Successfully', toastConfig)
  } catch (error) {
    console.error('Failed to delete patient:', error)
    toast.error('Failed to delete patient', toastConfig)
  } finally {
    setIsDeleting(false)
 }
}
 const parseResponseData = (response) => {
   const rawData = response?.d ?? response
   if (typeof rawData !== 'string') return rawData?.Data ?? rawData

   try {
     return JSON.parse(rawData)?.Data ?? []
   } catch (error) {
     throw new Error('Unable to parse patient deletion data.', { cause: error })
   }
 }

 const getPatientAppointmentId = (appointment) =>
   appointment?.patientID ?? appointment?.PatientID ?? appointment?.data?.PatientID

 const removePatientNotes = async (patientID) => {
   const response = await PatientNoteDataCRUD('GET', patientID)
   const notes = parseResponseData(response)

   if (!Array.isArray(notes)) {
     throw new Error('Patient notes data is not a valid array.')
   }

   await Promise.all(
     notes
       .map((note) => note?.id ?? note?.ID)
       .filter(Boolean)
       .map((noteID) => PatientNoteDataCRUD('DELETE', String(patientID), String(noteID))),
   )
 }

 const removePatientFromAppointments = async (patientID) => {
   const response = await PatientAppointmentDetails('GET', '', '', '', '')
   const schedules = parseResponseData(response)

   if (!Array.isArray(schedules)) {
     throw new Error('Appointment data is not a valid array.')
   }

   await Promise.all(
     schedules
       .map((schedule) => {
         const appointmentDetails =
           typeof schedule?.AppointmentDetails === 'string'
             ? parseResponseData({ d: schedule.AppointmentDetails })
             : schedule?.AppointmentDetails

         if (!Array.isArray(appointmentDetails)) return null

         const filteredDetails = appointmentDetails.filter(
           (appointment) => String(getPatientAppointmentId(appointment)) !== String(patientID),
         )

         if (filteredDetails.length === appointmentDetails.length) return null

         return PatientAppointmentDetails(
           'UPDATE',
           schedule.ID,
           schedule.ScheduleDate,
           schedule.ProviderID,
           JSON.stringify(filteredDetails),
           schedule.CreatedDate,
         )
       })
       .filter(Boolean),
   )
 }
  return (
    <div className="position-relative patient-theme-page" data-theme={patientTheme}>
      <Pageloader isLoading={isLoading} />

      <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme">
        <div className="page-header mb-3">
          <div className="d-flex align-items-center gap-1 patient-theme-toolbar">
            <div className="search-input search-dark dashboard-dark-search">
              <SearchIcon />
              <input
                type="text"
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
                placeholder="Search by Patient or Facility..."
              />
            </div>
             <div className="position-relative">
                              <Button className="d-flex align-items-center gap-2 dashboard-dark-filter-button" variant="outlined" size="large" onClick={() => setShowFilter(!showFilter)}>
                                <FunnelPlotOutlined />
                                Filter
                              </Button>                                                        
            
                              {showFilter && (
                                <motion.div
                                  initial={{ opacity: 0, y: 4 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: 4 }}
                                  transition={{ duration: 0.3, ease: 'easeInOut' }}
                                  style={{
                                    width: '300px',
                                    zIndex: 50,
                                  }}
                                  className="position-absolute gap-1 d-flex flex-column top-full left-0 z-10 shadow-lg p-4 rounded-md dashboard-dark-filter-popover patient-theme-filter-popover"
                                >
                                  <div>
                                    <CFormLabel>Select Facility</CFormLabel>
                                    <Select
                                      placeholder="Select"
                                      name="facility"
                                      options={facilities}
                                      value={facilities.filter((fac) => filterData.facility.includes(fac.value))}
                                      isMulti
                                      isClearable
                                      onChange={(selectedOptions) =>
                                        setFilterData((prev) => ({
                                          ...prev,
                                          facility: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                        }))
                                      }
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                    />
                                  </div>
            
                                  <div className="mt-3">
  <CFormLabel>Select Patient Type</CFormLabel>
  <Select
    name="patientType"
    isMulti
    isClearable
    placeholder="Select"
    options={selectPatientTypeOption}
    value={selectPatientTypeOption.filter((option) =>
      (filterData.patientType || []).includes(option.value)
    )}
    onChange={(selectedOptions) =>
      setFilterData((prev) => ({
        ...prev,
        patientType: selectedOptions
          ? selectedOptions.map((option) => option.value)
          : [],
      }))
    }
    className="basic-multi-select"
    classNamePrefix="select"
  />
</div>
            
                               <div className="mt-2" style={{ position: 'relative' }}>
  <CFormLabel>Select DOB</CFormLabel>

  <div>
    <CustomDatePickingFormat
      value={filterData.DOB || ''}
      aria-describedby="exampleFormControlInputHelpInline"
      onChange={(e) => {
        setFilterData((prev) => ({
          ...prev,
          DOB: e,
        }))
      }}
    />
  </div>

  {filterData.DOB && (
    <button
      onClick={() =>
        setFilterData((prev) => ({
          ...prev,
          DOB: '',
        }))
      }
      style={{
        position: 'absolute',
        left: '132px',
        zIndex: 2022220,
        top: '66%',
        width: '20px',
        height: '20px',
        transform: 'translateY(-50%)',
        border: 'none',
        cursor: 'pointer',
      }}
      className="d-flex align-items-center justify-content-center patient-theme-date-clear"
    >
      <X strokeWidth={3} size={30} />
    </button>
  )}
</div>
                                  <Button className="mt-3" onClick={() => setShowFilter(false)} variant="outlined">
                                    Close
                                  </Button>
                                </motion.div>
                              )}
                            </div>
          </div>

          <div className="d-flex align-items-center">
            <div className="display-total-patient mx-2">
              <span className="mx-1">{filteredPatients.length}</span> Archived Patients
            </div>
          </div>
        </div>

        {!isLoading && loadError && (
          <h6 className="d-flex justify-content-center text-danger">Unable to load archived patients</h6>
        )}

        {!isLoading && !loadError && (
          <div className="hide-drag-table">
            {facilityGroups.map(([facility, patients], facilityIndex) => (
              <div key={facility}>
                <CAccordion alwaysOpen className="dashboard-dark-accordion patient-theme-accordion">
                  <CAccordionItem
                    className="border-0 border-bottom my-2 mx-4 dashboard-dark-facility-item patient-theme-facility-item"
                    itemKey={`archive-facility-${facilityIndex}`}
                  >
                    <CAccordionHeader className="patient-theme-accordion-header" style={{ fontSize: '14px', boxShadow: 'unset' }}>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <span className="text-primary">
                          {facility} ({patients.length})
                        </span>
                      </div>
                    </CAccordionHeader>

                    <CAccordionBody className="border-bottom-0 border-0 py-0 p-0">
                      <CTable className="mb-0 border-bottom-0 border-0 patient-theme-table">
                        <CTableBody>
                          {patients.map((patient, patientIndex) => (
                            <CTableRow
                              className={`order-0 px-4 ${patient?.Status || ''} patient-row-list`}
                              key={patient?.PatientID || `${facility}-${patientIndex}`}
                              style={{ verticalAlign: 'middle', padding: '20px', top: 0 }}
                            >
                       
<CTableHeaderCell
  className="border-bottom-0 border-0"
  scope="row"
  style={{ width: '100%' }}
>
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: '260px minmax(0, 1fr)',
      alignItems: 'center',
      gap: '16px',
      width: '100%',
    }}
  >
    {/* Patient Name */}
    <span style={{ paddingLeft: '20px', minWidth: 0 }}>
      <span className="patient-name-fixed">
        {getPatientName(patient) || 'Unnamed Patient'}
      </span>
    </span>

    {/* Patient Details + Actions */}
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        minWidth: 0,
        width: '100%',
      }}
    >
      <span
        className="room-pill"
        style={{
          margin: 0,
          width: '180px',
          minWidth: '180px',
          maxWidth: '180px',
        }}
      >
        Room No: {patient?.Room || 'N/A'}
      </span>

      <span
        className="notestatus-pill"
        style={{ margin: 0 }}
      >
        Gender: {patient?.Gender || 'N/A'}
      </span>

      <span
        className="schedule-pill"
        style={{ margin: 0 }}
      >
        Age: {patient?.Age ?? 'N/A'}
      </span>

      {/* Actions */}
      <div
        className="button-wrapper d-flex align-items-center gap-2 ms-auto"
        style={{ flexShrink: 0 }}
      >


        <CButton
  color="primary"
  variant="outline"
  className="px-2"
  aria-label={`View note for ${
    getPatientName(patient) || 'patient'
  }`}
  onClick={() => handleViewNote(patient)}
>
  <CTooltip content="View Note">
    <Eye size={18} />
  </CTooltip>
</CButton>

        {/* Restore */}
        <CButton
          color="success"
          variant="outline"
          className="px-2"
          aria-label={`Restore ${
            getPatientName(patient) || 'patient'
          }`}
          onClick={() => setUnarchivePatient(patient)}
        >
          <CTooltip content="Restore patient">
            <RotateCcw size={18} />
          </CTooltip>
        </CButton>

        {/* Delete */}
        <CButton
          color="danger"
          variant="outline"
          className="px-2"
          aria-label={`Delete ${
            getPatientName(patient) || 'patient'
          }`}
          onClick={() => setDeletePatient(patient)}
        >
          <CTooltip content="Delete permanently">
            <Trash2 size={18} />
          </CTooltip>
        </CButton>
      </div>
    </div>
  </div>
</CTableHeaderCell>
                           </CTableRow>
                          ))}
                        </CTableBody>
                      </CTable>
                    </CAccordionBody>
                  </CAccordionItem>
                </CAccordion>
              </div>
            ))}

            {facilityGroups.length === 0 && (
              <h6 className="d-flex justify-content-center text-secondary">No archived patients found</h6>
            )}
          </div>
        )}

        <CModal
          visible={Boolean(unarchivePatient)}
          onClose={() => !isUnarchiving && setUnarchivePatient(null)}
          backdrop="static"
          className="dashboard-dark-modal patient-theme-modal"
          data-theme={patientTheme}
        >
          <CModalHeader>
            <CModalTitle>Confirm Restore</CModalTitle>
          </CModalHeader>
          <CModalBody>
            Are you sure you want to restore {getPatientName(unarchivePatient) || 'this patient'}?
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" disabled={isUnarchiving} onClick={() => setUnarchivePatient(null)}>
              Cancel
            </CButton>
            <CButton color="success" disabled={isUnarchiving} onClick={handleUnarchivePatient}>
              {isUnarchiving ? 'Restoring...' : 'Restore'}
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal
  visible={Boolean(deletePatient)}
  onClose={() => !isDeleting && setDeletePatient(null)}
  backdrop="static"
  className="dashboard-dark-modal patient-theme-modal"
  data-theme={patientTheme}
>
  <CModalHeader>
    <CModalTitle>Confirm Delete</CModalTitle>
  </CModalHeader>

  <CModalBody>
    <p className="text-white mb-2">
      Are you sure you want to delete this patient?
    </p>

    <p className="text-white mb-0">
      Deleting this patient will permanently remove all associated notes,
      appointments, and related details. This action cannot be undone, and
      the information cannot be restored.
    </p>
  </CModalBody>

  <CModalFooter>
    <CButton
      color="secondary"
      variant="outline"
      disabled={isDeleting}
      onClick={() => setDeletePatient(null)}
    >
      Cancel
    </CButton>

    <CButton
      color="danger"
      className="text-white px-3"
      disabled={isDeleting}
      onClick={handleDeletePatient}
    >
      {isDeleting ? 'Deleting...' : 'Delete Permanently'}
    </CButton>
  </CModalFooter>
</CModal>

<CModal
  size="lg"
  visible={patientModelVisible}
onClose={() => {
  setPatientModalVisible(false)
  setShowNotePopup(false)
}}
  className="dashboard-dark-modal patient-theme-modal"
  data-theme={patientTheme}
>
  <CModalBody
    className="view-data-modal"
    style={{
      padding: '2rem',
      borderRadius: '2rem',
      overflow: 'auto',
    }}
  >
   {showNotePopup && rowClicked && (
  <PatientViewNotePopup
    patientID={patientIDClicked}
    patientData={rowClicked}
    showCreateNote={false}
    showOnlyViewEye={true}
    showViewIcon={false}
    setPatientModalVisible={setShowNotePopup}
    setDataCallType={() => {}}
    setShowPatientInfo={() => {}}
    setEditDataId={() => {}}
    setNoteID={() => {}}
    noteStructureRef={{ current: {} }}
    appointment={[]}
    allAppointment={[]}
  />
)}
  </CModalBody>

  <CModalFooter>
   <Button
  variant="outlined"
  onClick={() => {
    setPatientModalVisible(false)
    setShowNotePopup(false)
    setShowPatientInfo(false)
    setPatientIDClicked(-1)
    setRowClicked(null)
    setDataCallType(null)
    setNoteID(null)
  }}
>
  Close
</Button>
  </CModalFooter>
</CModal>
      </div>
    </div>
  )
}

export default Archive
